
export enum BillingRemarkTypeCd {
	BILL_TO = 'BillTo',
	CONS = 'Cons',
	HZMT = 'Hzmt',
	OPERATIONS = 'Operations',
	SHPR = 'Shpr'}

